import React, { Component } from "react";
import { Form, Field } from "redux-form";

import { MODAL_TYPES } from "../../constants/modals";
import Button from "../shared/Button";

class CreateModelForm extends Component {
  constructor(props) {
    super(props);

    this.openCreateFolderModal = this.openCreateFolderModal.bind(this);
  }

  openCreateFolderModal() {
    this.props.openModal({ modalType: MODAL_TYPES.CREATE_FOLDER });
  }

  render() {
    const { error, handleSubmit } = this.props;
    const { byIds, allIds } = this.props.folders;

    return (
      <Form className="" onSubmit={handleSubmit}>
        {error && <div className="form__error pa2">{error}</div>}

        {/* folders */}
        {allIds.map(id => (
          <div
            key={id}
            className="radio__field radio__field--stacked pa2 bb f4 font-bold"
          >
            <Field
              id={id}
              name="folderId"
              component="input"
              type="radio"
              value={id}
            />
            <label htmlFor={id}>{byIds[id].title}</label>
          </div>
        ))}

        <div className="ph2 pv1 bb" onClick={this.openCreateFolderModal}>
          <Button additionalClassName="button--icon" icon="i-icon-plus" />
          <span className="pl2 f4">{this.props.t("common:newFolder")}</span>
        </div>

        <div className="ph2 pv3 w-80 tc center pointer">
          {/* cancel */}
          <button
            type="button"
            className="button mr3"
            onClick={this.props.closeModal}
          >
            {this.props.t("common:cancelButton")}
          </button>

          {/* submit */}
          <button className="button" type="submit">
            {this.props.t("common:saveButton")} <i className="i-arrow-right f7" />
          </button>
        </div>
      </Form>
    );
  }
}

export default CreateModelForm;



// WEBPACK FOOTER //
// ./src/components/forms/CreateModelForm.js